import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate, useOutletContext } from "react-router-dom";
import MpgInput from "../../../../../CommonFormComp/MpgInput";
import MpgFileUpload from "../../../../../fileHandling/MpgFileUpload";
import {
  useGetLanguageListQuery,
  useGetClientCodeListQuery,
  useGetAccountAdminListQuery,
  useGetCurrencyListQuery,
  useGetClientTypeClassificationQuery,
} from "../../../../../reactQueries/commonRQHooks";
import { useViewAccountTeamMembersListQuery } from "../../../../../reactQueries/AppApi/rqHooksForAccountTeamMembers";
import {
  useCreateClientAccountMutation,
  useUploadLogoOfClientAccountMutation,
} from "../../../../../reactQueries/AppApi/rqHooksForClientAccount";
import CircularProgress from "@mui/material/CircularProgress";
import { createClientAccValidation } from "./createClientAccValidation";
import ClientTeamTable from "../../accountTableComp/ClientTeamTable";
import AccountAdminTable from "../../accountTableComp/AccountAdminTable";
import AccountTeamTable from "../../accountTableComp/AccountTeamTable";
import AccountAdminsDialog from "../../AccountAdminsDialog";
import AccountTeamMemberDialog from "../../AccountTeamMemberDialog";
import Stack from "@mui/material/Stack";
import { clientAccountViewPath } from "../../../../../routes/routePaths";
import MpgErrorDialog from "../../../../../common/dialog/MpgErrorDialog";
import MpgLoadingDialog from "../../../../../common/dialog/MpgLoadingDialog";
import useTrackUserActivity from "../../../../../userActivityTracking/useTrackUserActivity";
import { getGUIDAndExtentionFromFileURL } from "../../../../../hooksAndFunctions/functions/getGUIDAndExtentionFromFileURL";
import MpgClientCodeTransferListDialogForClientAcc from "../../../../../CommonFormComp/MpgClientCodeTransferListForClientAcc/MpgClientCodeTransferListDialogForClientAcc";
import { Controller } from "react-hook-form";
import {
  mapLangListToAutocomplete,
  mapCurrencyListToAutocomplete,
  mapClientTypeListToAutocomplete,
  setClientCodes,
} from "../../../../../common/utilities/Helper";
import { getClientAccountCmsFetchers } from "../clientAccountCmsHelper";
import {
  buildAccountLanguages,
  mapAccountTeamMembersWithOrder,
  mapClientAccountAdmins,
  mapClientCodes,
} from "../../accountSubmitTransformHelper";
import ClientAccountDetailsFields from "../../ClientAccountDetailsFields";
import {
  useSupportiveLanguageOptions,
  useSyncAccountAdminsValidation,
} from "../../accountFormCommonHooks";
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const CreateClientAccount = () => {
  let navigate = useNavigate();
  const { refClientAccountCmsData } = useOutletContext();
  const {
    fetchClientAccountCmsData,
    fetchClientTeamMemberCmsData,
    fetchAccountTeamMemberCmsData,
    fetchAccountAdmnCmsData,
  } = getClientAccountCmsFetchers(refClientAccountCmsData);

  const userName = JSON.parse(window.sessionStorage.getItem("UserAccount"))?.[
    "name"
  ];

  /** !!!!!!!! form handling !!!!!!! */
  const { schema } = createClientAccValidation();

  const rhfFormInstance = useForm({
    resolver: yupResolver(schema),
    mode: "onChange", 
    reValidateMode: "onChange"
  });
  const { setValue, watch } = rhfFormInstance;
  const selectedPrimaryLang = watch("primary_lang");
  // console.log("selectedPrimaryLang", selectedPrimaryLang)

  /** !!!!!!!! table state handling !!!!!!! */
  const [accountTeamMemberTableData, setAccountTeamMemberTableData] =
    React.useState([]);
  const [accountAdminTableData, setAccountAdminTableData] = React.useState([]);
  const [wasAdminEdited, setWasAdminEdited] = useState(false);

  /** !!!!!!!! dialog state handling !!!!!!! */

  const [openAccountTeamDialog, setOpenAccountTeamDialog] =
    React.useState(false);
  const [openAccountAdminDialog, setOpenAccountAdminDialog] =
    React.useState(false);

  const [openClientAccCodeDialog, setOpenClientAccCodeDialog] = useState(false);

  const [openAllClientUserNotiDialog, setOpenAllClientUserNotiDialog] =
    useState(false);

  /** !!!!!!!! all API state handling !!!!!!! */
  const {
    isSuccess: isSuccessOnClientCodeList,
    data: ClientCodeListData,
    isFetching: isFetchingOnClientCodeList,
  } = useGetClientCodeListQuery();

  /**get master languagelist */
  const { data: LangList } = useGetLanguageListQuery();

  /**API calls to CreateClientAccount */
  const {
    mutate: createClientAccount,
    isError: isErrorOnCreate,
    isLoading: isLoadingOnCreate,
    isSuccess: isSuccessOnCreate,
    error: errorOnCreate,
  } = useCreateClientAccountMutation();

  const {
    mutate: uploadLogo,
    isError: isErrorOnLogoUpload,
    isLoading: isLoadingOnLogoUpload,
    isSuccess: isSuccessOnLogoUpload,
    data: dataOnLogoUpload,
  } = useUploadLogoOfClientAccountMutation();

  const { data: accountTeamMembersList } = useViewAccountTeamMembersListQuery();

  const { isSuccess: isSuccessOnAccAdminList, data: accountAdminListFromAPI } =
    useGetAccountAdminListQuery();

  const { data: CurrencyList } = useGetCurrencyListQuery();

  const { data: ClientTypeList } = useGetClientTypeClassificationQuery();

  /** !!!!!!!! autocomplete option lists !!!!!!! */
  const primaryLangAutocompleteList = mapLangListToAutocomplete(LangList);

  const currencyAutocompleteList = mapCurrencyListToAutocomplete(CurrencyList);

  const ClientTypeAutocompleteList =
    mapClientTypeListToAutocomplete(ClientTypeList);

  const supportiveLangAutocompleteList = useSupportiveLanguageOptions({
    LangList,
    selectedPrimaryLang,
  });

  /** !!!!!!!!! filtering Admin list on Permissions !!!!!!!!!! */
  /**for client accounts, admins with only A1 and A4 permisions allowed */
  const [filterAdminList, setFilterAdminList] = useState([]);
  useEffect(() => {
    if (!!isSuccessOnAccAdminList && !!accountAdminListFromAPI) {
      let newList = [];
      const regExp = /A1|A2|A4|Enterprise Admin/;
      accountAdminListFromAPI.forEach((item) => {
        if (item?.permissionRole.search(regExp) !== -1) {
          newList.push(item);
        }
      });
      setFilterAdminList(newList);
    }
  }, [accountAdminListFromAPI, isSuccessOnAccAdminList]);

  /** !!!!!!! grabing data from client code transfer list !!!!!! */
  const [finalCodeList, setFinalCodeList] = useState([]);
  // console.log("gl-final", finalCodeList)
  useEffect(() => {
    setClientCodes(finalCodeList, setValue);
  }, [finalCodeList, setValue]);

  /** !!!!!!!! submit handling !!!!!!! */
  const [bodyForCreate, setBodyForCreate] = useState({});
  const onSubmit = (data) => {
    const langList = buildAccountLanguages({
      primaryLangId: data.primary_lang?.id,
      supportedLangs: data.supported_lang || [],
    });

    const codeList = mapClientCodes({
      finalCodeList,
      codeKey: "clientCode",
      codeNameKey: "clientCodeName",
    });

    const accountTeamMembList = mapAccountTeamMembersWithOrder(
      accountTeamMemberTableData || []
    );

    const clientAccAdminList = mapClientAccountAdmins(accountAdminTableData || []);

    const body = {
      ClientAccountName: data.client_acc_name || "",
      Logo: "",
      IsActive: true,
      CreatedBy: userName || "",
      CurrencyId: data.CurrencyId?.id,
      DataClassificationKey: data.ClientType?.id,
      AccountLanguages: langList || [],
      ClientUserTeams: [],
      AccountUserTeams: accountTeamMembList || [],
      ClientAccountAdmins: clientAccAdminList || [],
      ClientAccountCodes: codeList || [],

      RemoveLogo: false,
    };
    setBodyForCreate(body);

    if (!!data.logo_img[0]) {
      const file = data.logo_img[0];
      uploadLogo({ file });
    } else {
      createClientAccount({ body });
    }
    // console.log("subForm", data)
  };

  useEffect(() => {
    if (!!isSuccessOnLogoUpload) {
      const storedFileURL = dataOnLogoUpload?.data?.FileUrl;
      const bodyData = {
        ...bodyForCreate,
        Logo: storedFileURL,
      };
      createClientAccount({ body: bodyData });
    }
  }, [isSuccessOnLogoUpload]);

  useEffect(() => {
    if (!!isSuccessOnCreate) {
      navigate(clientAccountViewPath);
    }
  }, [isSuccessOnCreate]);
  useSyncAccountAdminsValidation({
    rhfFormInstance,
    accountAdminTableData,
  });

  /**tracking user Activity */
  const { trackActivity } = useTrackUserActivity();
  useEffect(() => {
    if (!!isSuccessOnLogoUpload) {
      const { fileGUID } = getGUIDAndExtentionFromFileURL({
        fileURL: dataOnLogoUpload?.data?.FileUrl,
      });

      trackActivity({
        activitySuccess: !!isSuccessOnLogoUpload,
        actionType: "Uploaded",
        itemId: fileGUID || "",
      });
    }
  }, [isSuccessOnLogoUpload]);

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="h5" align="center" sx={{ fontWeight: "bolder" }}>
        {refClientAccountCmsData?.Components &&
          refClientAccountCmsData?.Components[
            "ClientAccountDetails.SetupClientAccount"
          ]?.Title}
      </Typography>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
        m={1}
      >
        <Button
          variant="outlined"
          size="small"
          component={Link}
          to={clientAccountViewPath}
        >
          {fetchClientAccountCmsData("ClientAccountDetails.ClientAccounts")}
        </Button>

        <Button variant="outlined" size="small" disabled>
          {fetchClientAccountCmsData("ClientAccountDetails.ViewAll")}
        </Button>
      </Stack>

      <Box sx={{ width: "100%" }}>
        <Box
          component="form"
          noValidate
          autoComplete="off"
          onSubmit={rhfFormInstance.handleSubmit(onSubmit)}
        >
          <Item>
            <Typography variant="h6" align="left" sx={{ fontWeight: "bolder" }}>
              {fetchClientAccountCmsData(
                "ClientAccountDetails.ClientAccountDetails"
              )}
            </Typography>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <ClientAccountDetailsFields
                  rhfFormInstance={rhfFormInstance}
                  fetchLabel={fetchClientAccountCmsData}
                  primaryLangAutocompleteList={primaryLangAutocompleteList || []}
                  supportiveLangAutocompleteList={supportiveLangAutocompleteList || []}
                  currencyAutocompleteList={currencyAutocompleteList || []}
                  clientTypeAutocompleteList={ClientTypeAutocompleteList || []}
                  selectedPrimaryLang={selectedPrimaryLang}
                />

                <MpgFileUpload
                  name={"logo_img"}
                  label={fetchClientAccountCmsData("ClientAccountDetails.Logo")}
                  rhfFormInstance={rhfFormInstance}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <div>
                  <MpgInput
                    rhfFormInstance={rhfFormInstance}
                    label={fetchClientAccountCmsData(
                      "ClientAccountDetails.SelectedClientCodes"
                    )}
                    name={"client_codes"}
                    multiline
                    rows={8}
                    fullWidth
                    disabled={true}
                  />
                  {!!isFetchingOnClientCodeList && (
                    <Button disabled>
                      <CircularProgress size={15} sx={{ margin: "5px" }} />
                      {fetchClientAccountCmsData("ClientAccountDetails.Fetch")}
                    </Button>
                  )}
                  {!!isSuccessOnClientCodeList && (
                    <Button
                      onClick={() => {
                        setOpenClientAccCodeDialog(true);
                      }}
                    >
                      {fetchClientAccountCmsData(
                        "ClientAccountDetails.SelectClientCodes"
                      )}
                    </Button>
                  )}
                </div>
              </Grid>
            </Grid>
          </Item>
          <br />
          <Item>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography
                variant="h6"
                align="center"
                sx={{ fontWeight: "bolder" }}
              >
                {refClientAccountCmsData?.Components &&
                  refClientAccountCmsData?.Components[
                    "ClientAccounts.ClientTeamMembers"
                  ]?.Title}
              </Typography>
              <Button variant="outlined" size="small" disabled>
                {fetchClientTeamMemberCmsData("ClientTeamMembers.Select")}
              </Button>
            </Stack>
            <ClientTeamTable tableData={[]} />
          </Item>
          <br />
          <Item>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography
                variant="h6"
                align="center"
                sx={{ fontWeight: "bolder" }}
              >
                {refClientAccountCmsData?.Components &&
                  refClientAccountCmsData?.Components[
                    "ClientAccounts.AccountTeamMembers"
                  ]?.Title}
              </Typography>
              <Button
                variant="outlined"
                size="small"
                onClick={() => {
                  setOpenAccountTeamDialog(true);
                }}
              >
                {fetchAccountTeamMemberCmsData("AccountTeamMembers.Select")}
              </Button>
            </Stack>
            <AccountTeamTable
              tableData={accountTeamMemberTableData || []}
              setTableData={setAccountTeamMemberTableData}
            />
          </Item>
          <br />
          <Item
            sx={{
              border: rhfFormInstance.formState.errors.accountAdmins && (rhfFormInstance.formState.isSubmitted|| wasAdminEdited)
                ? "1px solid red"
                : undefined,
              borderRadius: 1,
              pb: 1,
            }}
          >
            <Stack
              direction={{ xs: "column", sm: "row" }}
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography
                variant="h6"
                align="center"
                sx={{ fontWeight: "bolder" }}
              >
                {refClientAccountCmsData?.Components &&
                  refClientAccountCmsData?.Components[
                    "ClientAccounts.AccountAdmins"
                  ]?.Title}
              </Typography>
              <Button
                variant="outlined"
                size="small"
                onClick={() => {
                  setOpenAccountAdminDialog(true);
                }}
              >
                {fetchAccountAdmnCmsData("AccountAdmins.Select")}
              </Button>
            </Stack>

            <AccountAdminTable
              tableData={accountAdminTableData || []}
              setTableData={setAccountAdminTableData}
              rhfFormInstance={rhfFormInstance}
              setWasAdminEdited={setWasAdminEdited}
            />

            {rhfFormInstance.formState.errors.accountAdmins && (rhfFormInstance.formState.isSubmitted|| wasAdminEdited) && (
              <Typography
                color="error"
                variant="caption"
                align="left"
                sx={{ px: 2, pt: 1 }}
              >
                {rhfFormInstance.formState.errors.accountAdmins.message}
              </Typography>
            )}
          </Item>

          <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent={"space-evenly"}
            mt={3}
          >
            <Button variant="contained" size="small" type="submit">
              {fetchClientAccountCmsData(
                "ClientAccountDetails.CreateClientAccount"
              )}
            </Button>
          </Stack>
        </Box>
      </Box>

      <AccountTeamMemberDialog
        open={openAccountTeamDialog}
        setOpen={setOpenAccountTeamDialog}
        accountTeamMemberTableData={accountTeamMemberTableData || []}
        setAccountTeamMemberTableData={setAccountTeamMemberTableData}
        accountTeamMembersListFromAPI={accountTeamMembersList || []}
      />
      <AccountAdminsDialog
        open={openAccountAdminDialog}
        setOpen={setOpenAccountAdminDialog}
        accountAdminTableData={accountAdminTableData || []}
        setAccountAdminTableData={setAccountAdminTableData}
        accountAdminListFromAPI={filterAdminList || []}
      />

      <MpgClientCodeTransferListDialogForClientAcc
        transferDialogTitle={fetchClientAccountCmsData(
          "ClientAccountDetails.SelectClientCodes"
        )}
        leftTableTitle={fetchClientAccountCmsData(
          "ClientAccountDetails.AvailableClientCodes"
        )}
        rightTableTitle={fetchClientAccountCmsData(
          "ClientAccountDetails.SelectedClientCodes"
        )}
        open={openClientAccCodeDialog}
        setOpen={setOpenClientAccCodeDialog}
        grabRightTableData={setFinalCodeList}
        leftTableDataToPop={ClientCodeListData}
        rightTableDataToPop={finalCodeList}
        whereUsed={"Create"}
      />

      {/** error dialog on create action */}
      <MpgErrorDialog
        open={!!isErrorOnCreate || !!isErrorOnLogoUpload}
        title={`${
          !!isErrorOnCreate &&
          errorOnCreate?.response?.data === "AccountNameExists"
            ? fetchClientAccountCmsData(
                "ClientAccountDetails.ValidationMsgAccountNameExists"
              )
            : ""
        }`}
        content={`${
          !!isErrorOnCreate &&
          errorOnCreate?.response?.data === "AccountNameExists"
            ? fetchClientAccountCmsData(
                "ClientAccountDetails.ValidationMsgDuplicateAccountName"
              ).replace("#CLIENT_ACCOUNT_NAME", `${watch("client_acc_name")}`)
            : ""
        }`}
      />
      <MpgLoadingDialog open={!!isLoadingOnCreate || !!isLoadingOnLogoUpload} />
    </Box>
  );
};

export default CreateClientAccount;
